import React, { useCallback, useEffect, useState } from 'react';
import { Slider } from 'antd-v5';
import { InputRangeProps } from './InputSlider.types';

type RangeValue = InputRangeProps['value'];
const isRangeValue = (sliderValue: number[]): sliderValue is RangeValue => sliderValue.length === 2;

export const InputRange = ({ value, onChange, min, max, tipFormatter, disabled, step }: InputRangeProps) => {
  const [inputValue, setInputValue] = useState(value);
  const [isDragging, setIsDragging] = useState(false);

  useEffect(() => {
    if (!isDragging) {
      setInputValue(value);
    }
  }, [value, isDragging]);

  useEffect(() => {
    if (!isDragging) {
      return undefined;
    }

    const stopDragging = () => {
      setIsDragging(false);
    };

    globalThis.addEventListener('mouseup', stopDragging);
    globalThis.addEventListener('touchend', stopDragging);

    return () => {
      globalThis.removeEventListener('mouseup', stopDragging);
      globalThis.removeEventListener('touchend', stopDragging);
    };
  }, [isDragging]);

  const handleChange = useCallback((val: number[]) => {
    if (!isRangeValue(val)) {
      return;
    }

    setIsDragging(true);
    setInputValue(val);
  }, []);

  const handleChangeComplete = useCallback(
    (val: number[]) => {
      setIsDragging(false);
      if (onChange && isRangeValue(val)) {
        onChange(val);
      }
    },
    [onChange],
  );

  return (
    <Slider
      range
      value={inputValue as number[]}
      onChange={handleChange}
      onChangeComplete={handleChangeComplete}
      disabled={disabled}
      min={min}
      step={step}
      max={max}
      tooltip={{ formatter: tipFormatter }}
    />
  );
};
